export const DEFAULT_NULL_INDEX = -1;
export const INIT_MAX_NUMBER = 1000;
export const DEFAULT_DATA_URL_KEY = 'dataURL';
